import PeluangRAB from './PeluangRAB';

export default PeluangRAB;
